import React from 'react';
import { Modal, View, TouchableOpacity, Image, ImageSourcePropType } from 'react-native';
import Typography from '../Text/Text';
import { styles } from './BottomModal.styles';
import closeCircle from 'src/assets/close.png';

interface RadioModalProps {
  isVisible: boolean;
  onClose: () => void;
  title?: string;
  style?: object;
  children?: React.ReactNode;
  closeIcon?: ImageSourcePropType;
}

const BottomModal: React.FC<RadioModalProps> = ({
  isVisible,
  onClose,
  title,
  style,
  closeIcon,
  children,
}) => {
  return (
    <Modal visible={isVisible} transparent animationType="slide">
      <View style={styles.modalOverlay}>
        <View style={[styles.modalContainer, style]}>
          {/* Modal header */}
          <View style={styles.header}>
            <Typography variant="h2">{title}</Typography>
            <TouchableOpacity onPress={onClose} style={styles.closeIcon}>
              <Image source={closeIcon ? closeIcon : closeCircle} style={styles.closeImage} />
            </TouchableOpacity>
          </View>
          {children}
        </View>
      </View>
    </Modal>
  );
};

export default BottomModal;
